<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      <div class="row">
        @for (owner of owners.controls; track owner; let index = $index) {
          <ng-container [formGroup]="owner">
            <div class="col-md-{{ owners?.length > 1 ? 6 : 12 }}">
              <owner-header [owners]="owners" [index]="index"></owner-header>
              <div class="row">
                <div class="col col-md-12">
                  <pr-input-column
                    label="Nombre de personnes à charge (ex : enfants, personnes âgées)"
                    [derrors]="derrors"
                  >
                    <input
                      notdot
                      formControlName="personnesInCharge"
                      type="number"
                      placeholder="Exemple : 2"
                    />
                  </pr-input-column>
                </div>
              </div>
            </div>
          </ng-container>
        }
      </div>
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
